import hscTeamMembers from "../../hsc-team-members";
import {calculateTotalColumn, formatName, getHSCCumulativeAgentPercent, getHSCCumulativeThreshold} from "../../utils";

export class HscPipelineFeesModel {
    id;
    date;
    property;
    totalFee;
    referral;
    bankBonus;
    credits;
    hscGross;
    cumulative;
    agentNet;
    hscNet;
    referredBy;
    loanAmount;

    constructor({data, previousCumulative, isTotal, year, location}) {
        let teamMembers=[]
        const teamMemberEmails = location.query.HSC_TEAM_MEMBERS ? location.query.HSC_TEAM_MEMBERS.split(',') : '';
        if(teamMemberEmails)
            teamMemberEmails.map((teamMemberEmail) => teamMembers.push(hscTeamMembers.find(el => el.EMAIL === teamMemberEmail)));
        if (isTotal) {
            this.date = null;
            this.property = year === 'closed' ? 'TOTAL:' : `${year} TOTAL:`;
            this.totalFee = calculateTotalColumn(data, 'totalFee');
            this.referral = calculateTotalColumn(data, 'referral');
            this.bankBonus = calculateTotalColumn(data, 'bankBonus');
            this.credits = calculateTotalColumn(data, 'credits');
            this.hscGross = calculateTotalColumn(data, 'hscGross');
            this.cumulative = data[data.length - 1].cumulative;
            this.agentNet = calculateTotalColumn(data, 'agentNet');
            this.hscNet = calculateTotalColumn(data, 'hscNet');
            this.referredBy = null;
            this.loanAmount = calculateTotalColumn(data,'loanAmount');
        } else {
            this.id = data.ARCIMEDES_ROW_ID;
            this.date = data && data.LOAN_CLOSING_DATE ? data.LOAN_CLOSING_DATE.split(' ')[0] : '';
            this.property = data && data.NAME ? `${data.NAME} - ${data.CITY ? data.CITY : ''}, ${data.STATE ? data.STATE : ''}` : '';
            this.totalFee = data && data.HSC_TOTAL_FEE ? data.HSC_TOTAL_FEE : 0;
            this.referral = data && data.REFERRAL ? data.REFERRAL : 0;
            this.bankBonus = data && data.BANK_BONUS ? data.BANK_BONUS : 0;
            this.credits = data && data.CREDITS ? data.CREDITS : 0;
            this.hscGross = data && data.HSC_LIST_FEE ? ((parseFloat(data.HSC_TOTAL_FEE) || 0) - (parseFloat(data.REFERRAL) || 0) - (parseFloat(data.CREDITS) || 0) + (parseFloat(data.BANK_BONUS) || 0)) : 0;
            if(teamMemberEmails && teamMemberEmails.length < 2){
                if(data.HSC_TEAM_MEMBER_1 === teamMemberEmails[0])
                    this.hscGross = ((parseFloat(data.HSC_TOTAL_FEE) || 0) - (parseFloat(data.REFERRAL) || 0) - (parseFloat(data.CREDITS) || 0) + (parseFloat(data.BANK_BONUS) || 0)) * data.HSC_TEAM_MEMBER_1_PERCENT/100;
                else if(data.HSC_TEAM_MEMBER_2 === teamMemberEmails[0])
                    this.hscGross = ((parseFloat(data.HSC_TOTAL_FEE) || 0) - (parseFloat(data.REFERRAL) || 0) - (parseFloat(data.CREDITS) || 0) + (parseFloat(data.BANK_BONUS) || 0)) * data.HSC_TEAM_MEMBER_2_PERCENT/100;
            }
            this.cumulative = this.hscGross ? this.hscGross + previousCumulative : previousCumulative;
            const agentPreviousPercent = getHSCCumulativeAgentPercent(previousCumulative);
            const agentPercent = getHSCCumulativeAgentPercent(this.cumulative);
            const threshold = getHSCCumulativeThreshold(this.cumulative);
            if (agentPreviousPercent !== agentPercent)
                this.agentNet = (threshold - previousCumulative) * agentPreviousPercent + (this.cumulative - threshold) * agentPercent;
            else
                this.agentNet = this.hscGross ? this.hscGross * agentPercent : 0;
            this.hscNet = this.hscGross && this.agentNet ? this.hscGross - this.agentNet : 0;
            this.loanAmount = data && data.LOAN_AMOUNT ? data.LOAN_AMOUNT : 0;
            if (data && data.AGENT_FIRST_NAME)
                this.referredBy = formatName(data, 'AGENT_');
            else if (data && data.TEAM_FIRST_NAME)
                this.referredBy = formatName(data, 'TEAM_');
            else
                this.referredBy = '';
        }
    }
}

export class HscPipelineFeesTotals {
    title;
    totalFee;
    referral;
    bank_bonus;
    credits;
    hscGross;
    cumulative;
    agentNet;
    hscNet;
    loanAmount;

    constructor({data, year, isCurrentYear, isTotal, location}) {
        let teamMembers=[]
        const teamMemberEmails = location.query.HSC_TEAM_MEMBERS ? location.query.HSC_TEAM_MEMBERS.split(',') : '';
        if(teamMemberEmails)
            teamMemberEmails.map((teamMemberEmail) => teamMembers.push(hscTeamMembers.find(el => el.EMAIL === teamMemberEmail)));
        this.title = isTotal ? 'TOTAL' : `${year} TOTAL:`;
        if (isTotal) {
            this.totalFee = calculateTotalColumn(data, 'totalFee');
            this.referral = calculateTotalColumn(data, 'referral');
            this.bankBonus = calculateTotalColumn(data, 'bankBonus');
            this.credits = calculateTotalColumn(data, 'credits');
            this.hscGross = calculateTotalColumn(data, 'hscGross');
            this.cumulative = calculateTotalColumn(data, 'cumulative');
            this.agentNet = calculateTotalColumn(data, 'agentNet');
            this.hscNet = calculateTotalColumn(data, 'hscNet');
            this.loanAmount = calculateTotalColumn(data,'loanAmount');
        } else if (isCurrentYear) {
            const lastIndex = data.length - 1;
            this.totalFee = data[lastIndex] ? data[lastIndex].totalFee : 0;
            this.referral = data[lastIndex] ? data[lastIndex].referral : 0;
            this.bankBonus = data[lastIndex] ? data[lastIndex].bankBonus : 0;
            this.credits = data[lastIndex] ? data[lastIndex].credits : 0;
            this.hscGross = data[lastIndex] ? data[lastIndex].hscGross : 0;
            // this.hscGross = this.totalFee - this.referral - this.credits + this.bankBonus;
            this.cumulative = data[lastIndex] ? data[lastIndex].cumulative : 0;
            this.agentNet = data[lastIndex] ? data[lastIndex].agentNet : 0;
            this.hscNet = data[lastIndex] ? data[lastIndex].hscNet : 0;
            this.loanAmount = data[lastIndex] ? data[lastIndex].loanAmount : 0;
        } else {
            this.totalFee = data && data.length ? calculateTotalColumn(data, 'HSC_TOTAL_FEE') : 0;
            this.referral = data && data.length ? calculateTotalColumn(data, 'REFERRAL') : 0;
            this.bankBonus = data && data.length ? calculateTotalColumn(data, 'BANK_BONUS') : 0;
            this.credits = data && data.length ? calculateTotalColumn(data, 'CREDITS') : 0;
            this.hscGross = this.totalFee - this.referral - this.credits + this.bankBonus;
            if(teamMemberEmails && teamMemberEmails.length < 2){
                if(data.HSC_TEAM_MEMBER_1 === teamMemberEmails[0]){
                    this.hscGross = data.reduce((accumulator, property) => {
                        return accumulator + ((parseFloat(property.HSC_TOTAL_FEE) || 0) - (parseFloat(property.REFERRAL) || 0) - (parseFloat(property.CREDITS) || 0) + (parseFloat(property.BANK_BONUS) || 0)) * property.HSC_TEAM_MEMBER_1_PERCENT/100;
                    }, 0);
                }else if(data.HSC_TEAM_MEMBER_2 === teamMemberEmails[0]){
                    this.hscGross = data.reduce((accumulator, property) => {
                        return accumulator + ((parseFloat(property.HSC_TOTAL_FEE) || 0) - (parseFloat(property.REFERRAL) || 0) - (parseFloat(property.CREDITS) || 0) + (parseFloat(property.BANK_BONUS) || 0)) * property.HSC_TEAM_MEMBER_2_PERCENT/100;
                    }, 0);
                }
            }
            this.cumulative = this.hscGross;
            if (data && data.length)
                this.agentNet = data.reduce((accumulator, property) => {
                    let previousCumulative = property.HSC_LIST_FEE ? property.cumulative - parseFloat(property.HSC_LIST_FEE) : property.cumulative;
                    let agentNet = 0;
                    const agentPreviousPercent = getHSCCumulativeAgentPercent(previousCumulative);
                    const agentPercent = getHSCCumulativeAgentPercent(property.cumulative);
                    const threshold = getHSCCumulativeThreshold(property.cumulative);
                    if (agentPreviousPercent !== agentPercent)
                        agentNet = (threshold - previousCumulative) * agentPreviousPercent + (property.cumulative - threshold) * agentPercent;
                    else
                        agentNet = property.HSC_LIST_FEE ? parseFloat(property.HSC_LIST_FEE) * agentPercent : 0;
                    return accumulator + agentNet;
                }, 0);
            else this.agentNet = 0;
            this.hscNet = this.hscGross && this.agentNet ? this.hscGross - this.agentNet : 0;
            this.loanAmount = data && data.length ? calculateTotalColumn(data, 'LOAN_AMOUNT') : 0;
        }
    }
}